import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import ButtonGroupField from '../../formFields/buttonGroupField';
import { reduxFormFieldWrapper } from '../reduxFormFieldWrapper';
export default reduxFormFieldWrapper(fieldProps => (_jsx(ButtonGroupField, { ...fieldProps })));
//# sourceMappingURL=index.js.map